import React, { useState, useEffect, useRef } from 'react';
import { TextInput, Filter } from 'react-admin';

/**
 * TextInput com debounce robusto que previne travamentos
 */
export const SafeTextInput = ({ onChange, delay = 600, ...props }) => {
  const [value, setValue] = useState('');
  const timeoutRef = useRef(null);
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);

    // Limpa timeout anterior
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Aplica debounce
    timeoutRef.current = setTimeout(() => {
      if (mountedRef.current && onChange) {
        onChange({ target: { value: newValue } });
      }
    }, delay);
  };

  return (
    <TextInput
      {...props}
      value={value}
      onChange={handleChange}
    />
  );
};

/**
 * Versão mais simples do filtro de busca
 * Com proteção contra travamentos
 */
export const SimpleSearchFilter = ({ children, ...props }) => (
  <Filter {...props}>
    <SafeTextInput 
      label="Procurar" 
      source="q" 
      alwaysOn
      variant="outlined"
      size="small"
      delay={600}
    />
    {children}
  </Filter>
);

export default SimpleSearchFilter;